import type { TFunction } from 'i18next';

/**
 * Generates a WhatsApp message for administrator leads based on the user's language
 * @param t - Translation function from i18next
 * @param firstName - First name of the administrator lead (already in proper case)
 * @param userName - Name of the logged-in user (already in proper case)
 * @returns Formatted WhatsApp message string
 */
export const generateWhatsAppMessage = (
  t: TFunction,
  firstName: string,
  userName: string
): string => {
  const template = t('sales:administratorLeads.messages.whatsappTemplate');
  
  // Debug logging
  console.log('WhatsApp Message Generation:', {
    firstName,
    userName,
    template: template.substring(0, 100) + '...'
  });
  
  const result = template
    .replace('{firstName}', firstName)
    .replace('{userName}', userName);
    
  console.log('Final WhatsApp Message:', result);
  
  return result;
};

/**
 * Formats a phone number for WhatsApp URL
 * @param phone - Raw phone number string
 * @returns Formatted phone number with country code
 */
export const formatPhoneForWhatsApp = (phone: string): string => {
  if (!phone) return '';
  
  // Remove all non-digit characters
  let cleanPhone = phone.replace(/\D/g, '');
  
  // Add country code if missing
  if (cleanPhone.length === 10) {
    cleanPhone = '1' + cleanPhone; // Add US country code
  } else if (cleanPhone.length === 11 && cleanPhone.startsWith('1')) {
    // Already has US country code
  } else if (cleanPhone.length === 9 && cleanPhone.startsWith('9')) {
    cleanPhone = '56' + cleanPhone; // Add Chile country code
  } else if (cleanPhone.length === 8 && cleanPhone.startsWith('2')) {
    cleanPhone = '56' + cleanPhone; // Add Chile country code for mobile
  }
  
  return cleanPhone;
};

/**
 * Creates a WhatsApp URL with the formatted message
 * @param phone - Raw phone number string
 * @param message - WhatsApp message to send
 * @returns Complete WhatsApp URL
 */
export const createWhatsAppUrl = (phone: string, message: string): string => {
  const formattedPhone = formatPhoneForWhatsApp(phone);
  return `https://wa.me/${formattedPhone}?text=${encodeURIComponent(message)}`;
};
